import React from "react";
import Head from "../../components/Head/Head";
import Footer from "../../components/Footer/Footer";
import Body from "../../components/DashboardBody/Body";
import "./dashboard.css";

const DashBoard = () => {
    return (
        <div className="dashboard-shell">
            <Head />
            <main className="dashboard-main">
                <Body />
            </main>
            <Footer />
        </div>
    )
}

export default DashBoard;
